/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import _ from 'lodash';
import {
  Alert,
  Box,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Chip as MuiChip,
  Collapse,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Link,
  Paper as MuiPaper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { green, orange, red } from '@mui/material/colors';
import { LogoutOutlined } from '@mui/icons-material';
import { spacing } from '@mui/system';
import { makeStyles, withStyles } from '@mui/styles';
import Loading from '../components/Loading';
import { socket } from '../../sockets/socket';
import moment from 'moment';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { connect } from 'react-redux';

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);
const useStyles = makeStyles({
  tableCell: {
    padding: '0px 12px 0px 0px',
    width: '1000px',
  },
});
const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);
const Chip = styled(MuiChip)`
  ${spacing};
  background: ${(props) => props.shipped && green[500]};
  background: ${(props) => props.processing && orange[700]};
  background: ${(props) => props.cancelled && red[500]};
  color: ${(props) => props.theme.palette.common.white};
`;
const Spacer = styled.div`
  flex: 1 1 100%;
`;
const ToolbarTitle = styled.div`
  min-width: 150px;
`;
const headCells = [
  { key: 'id', alignment: 'left', label: 'Sr. No' },
  { key: 'user_type', alignment: 'left', label: 'User Type' },
  { key: 'user_name', alignment: 'left', label: 'User Name' },
  { key: 'email_address', alignment: 'left', label: 'Email Address' },
  { key: 'company', alignment: 'left', label: 'Company' },
  { key: 'role', alignment: 'left', label: 'Role' },
  { id: 'sessions', alignment: 'center', label: 'Sessions' },
  { id: 'collapse', alignment: 'center', label: '' },
];

function createData(id, name, email_address, company, role, user_type, logged_at, location) {
  return {
    id,
    name,
    email_address,
    company,
    role,
    user_type,
    logged_at,
    location,
  };
}

function buildGoogleMapURL(coordinates) {
  return `https://www.google.com/maps/place/${coordinates?.latitude},${coordinates?.longitude}`;
}

const EnhancedTableHead = (props) => {
  const [head, setHeads] = useState(headCells);

  return (
    <TableHead>
      <TableRow>
        {head.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? 'none' : 'normal'}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  return (
    <Toolbar>
      <ToolbarTitle>
        <Typography color={'primary'} variant='h6' id='tableTitle'>
          All Active Users
        </Typography>
      </ToolbarTitle>
      <Spacer />
    </Toolbar>
  );
};

function EnhancedTable({ onlineUsers, onLogoutUser, apOnlineUsers }) {
  const anchorRef = React.useRef(null);
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = useState(apOnlineUsers);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const [message, setMessage] = useState(location?.state?.message);
  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const [openCol, setOpenCol] = useState(-1);
  if (!loader) {
    return (
      <div>
        <Button
          ref={snackRef}
          style={{ display: 'none' }}
          onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
        >
          Click
        </Button>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          <Alert mt={2} mb={4} severity='success'>
            {message}
          </Alert>
        </Snackbar>
        <Paper>
          <EnhancedTableToolbar
            setRows={setRows}
            setLoader={setLoader}
            anchorRef={anchorRef}
            numSelected={selected.length}
          />
          <StyledTableContainer>
            <Table aria-labelledby='tableTitle' size={'small'} aria-label='enhanced table'>
              <EnhancedTableHead numSelected={selected.length} />
              <TableBody>
                {apOnlineUsers.map((row, index) => {
                  return (
                    <React.Fragment>
                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                        <TableCell align='left'>{index + 1}</TableCell>
                        <TableCell align='left'>{_.upperCase(String(row.user_type))}</TableCell>
                        <TableCell align='left'>{row?.user_details?.name}</TableCell>
                        <TableCell align='left'>{row?.user_details?.email_address}</TableCell>
                        <TableCell align='left'>
                          {row.company_details ? row.company_details?.name : 'SELF'}
                        </TableCell>
                        <TableCell align='left'>
                          {row.role_info ? row.role_info?.role_name : 'Admin'}
                        </TableCell>
                        <TableCell align='center'>
                          <Chip
                            label={row.sessions?.length > 9 ? '9+' : row.sessions?.length}
                            color='primary'
                            size='small'
                            sx={{ borderRadius: '50%' }}
                          />
                        </TableCell>
                        <TableCell>
                          <IconButton
                            aria-label='expand row'
                            size='small'
                            onClick={() => setOpenCol(index === openCol ? -1 : index)}
                          >
                            {openCol === index ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )}
                          </IconButton>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                          <Collapse in={openCol === index} timeout='auto' unmountOnExit>
                            <Box sx={{ padding: 4, marginBottom: 4 }}>
                              <Typography variant='h6' component='div' sx={{ mb: 2 }}>
                                Sessions
                              </Typography>
                              <Table size='small' aria-label='purchases'>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Login Time</TableCell>
                                    <TableCell>Time Lapsed</TableCell>
                                    <TableCell>Location</TableCell>
                                    <TableCell>Google Map</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {Array.isArray(row.sessions) &&
                                    row.sessions.map((log, i) => (
                                      <TableRow key={i}>
                                        <TableCell component='th' scope='row'>
                                          {moment(new Date(log.login_time)).calendar()}
                                        </TableCell>
                                        <TableCell>
                                          {moment(new Date(log.login_time)).fromNow()}
                                        </TableCell>
                                        <TableCell>{log.login_place?.address_details}</TableCell>
                                        <TableCell>
                                          <IconButton
                                            aria-label='map-open'
                                            onClick={() => {
                                              window
                                                .open(
                                                  buildGoogleMapURL(log?.login_place?.coordinates),
                                                  '_blank'
                                                )
                                                .focus();
                                            }}
                                          >
                                            <OpenInNewIcon />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell align='center'>
                                          <Tooltip
                                            title={
                                              socket.id === log.socket_id
                                                ? 'Current Session'
                                                : 'Logout'
                                            }
                                          >
                                            <LogoutOutlined
                                              style={{
                                                cursor:
                                                  socket.id === log.socket_id
                                                    ? 'default'
                                                    : 'pointer',
                                                color: socket.id === log.socket_id ? '#ccc' : 'red',
                                              }}
                                              onClick={() => {
                                                if (socket.id !== log.socket_id) {
                                                  socket.emit(
                                                    'force_logout_user_command',
                                                    log.socket_id
                                                  );
                                                }
                                              }}
                                            />
                                          </Tooltip>
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                </TableBody>
                              </Table>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </StyledTableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component='div'
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </div>
    );
  } else {
    return <Loading />;
  }
}

function Sessions({ auths, apOnlineUsers }) {
  const token = JSON.parse(localStorage.getItem('AuthData'));
  const [loader, setLoader] = useState(false);
  const [onlineUsers, setOnlineUsers] = useState([]);
  const authData = JSON.parse(localStorage.getItem('AuthData'));

  const onLogoutUser = (user_id, access_token) => {
    if (user_id) {
      socket.emit('logout_user', {
        user_id: user_id,
        access_token: access_token,
      });
    }
  };

  useEffect(() => {
    socket.emit('get_online_users', {});

    const getOnlineUsersHandler = (data) => {
      setLoader(true);
      let rows = [];
      Object.values(data)
        .reverse()
        .map((res) => {
          let company;
          let role;
          let userData = res.user_data;
          let logs = res.logs;

          if (userData.user_type === 'ap_user') {
            let companies = [];
            userData.ap_company.map((com) => companies.push(com.name));
            company = companies.join(',');
          } else if (userData.user_type === 'customer_user') {
            company = userData.customer_company.name;
          } else {
            company = null;
          }

          let obj = {
            id: '',
            name: '',
            email_address: '',
            company: '',
            role: '',
            user_type: '',
          };

          if (userData.user_type !== 'super_admin') {
            obj.id = userData._id;
            obj.name = userData.name;
            obj.email_address = userData.email_address;
            obj.company = company;
            obj.role = userData.role.role_name;
            obj.user_type = userData.user_type;
          } else {
            obj.id = userData._id;
            obj.name = userData.name;
            obj.email_address = userData.email_address;
            obj.role = 'SUPER ADMIN';
            obj.user_type = 'super_admin';
          }

          let sortedLogs = logs.sort(function compare(a, b) {
            var dateA = new Date(a.logged_at);
            var dateB = new Date(b.logged_at);
            return dateB - dateA;
          });
          obj.logs = sortedLogs;
          rows.push(obj);
        });
      setOnlineUsers(rows);
      setLoader(false);
    };
    const userLoggedOutHandler = () => {
      setLoader(true);
      socket.emit('get_online_users', {});
      setLoader(false);
    };

    const userLoggedInHandler = () => {
      setLoader(true);
      socket.emit('get_online_users', {});
      setLoader(false);
    };

    socket.on('user_logged_out', userLoggedOutHandler);
    socket.on('get_online_users', getOnlineUsersHandler);
    socket.on('user_logged_in', userLoggedInHandler);

    return () => {
      socket.off('get_online_users', getOnlineUsersHandler);
      socket.off('user_logged_out', userLoggedOutHandler);
      socket.off('user_logged_in', userLoggedInHandler);
    };
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              SESSIONS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Typography>Sessions</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {apOnlineUsers && apOnlineUsers.length > 0 && (
              <EnhancedTable
                apOnlineUsers={apOnlineUsers}
                onlineUsers={onlineUsers}
                onLogoutUser={onLogoutUser}
              />
            )}
            {!apOnlineUsers ||
              (apOnlineUsers.length === 0 && (
                <Paper
                  sx={{
                    height: 'calc(100vh - 208px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography component='h2' variant='h3' align='center' gutterBottom>
                    No active users! 🧑‍💻
                  </Typography>
                </Paper>
              ))}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  apOnlineUsers: state.sessionManager,
});
export default connect(mapStateToProps)(Sessions);
